// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 185 ? "babelTransform" : chunkId) + "-chunk-" + {"114":"8aa50d846ac6836da5b6","185":"ed8b0911a7981b95f822"}[chunkId] + ".js";
};